import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_CONSTATNTS: 'GET_CONSTATNTS'
  })
};

export const getConstants = createAsyncAction(types.GET_CONSTATNTS, () => {
  return Promise.all([
    api.get(`v1/job-functions`),
    api.get(`v1/industries`),
    api.get(`v1/contract-types`),
    api.get(`v1/job-periods`)
  ]).then((result) => ({
    functionsDirections: result[0].data.Data,
    industries: result[1].data.Data,
    contractTypes: result[2].data.Data,
    filterPeriods: result[3].data.Data
  }));
});
